import React from 'react'
import styled from 'styled-components'
import { Card, CardActionArea } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import NextRouter from 'next/router'
import { ImgWithSkeleton } from 'components/Card'

type Props = {
  artist: any
}

export default function Artist({ artist }: Props) {
  const s = useStyle({})

  return (
    <Card className={s.card}>
      <CardActionArea
        onClick={() => {
          NextRouter.push('/artists/' + artist.accountId)
        }}
      >
        <SquareBox>
          <ImgWithSkeleton
            id={`artist-${artist.id ?? artist.objectID}`}
            src={artist.avatar?.uri}
            alt={artist.displayName}
            imgWrapperClassName={s.imgWrapper}
            imgClassName={s.img}
            aspectRatio={1}
            borderRadiusOverWidth={0.1}
          />
        </SquareBox>
        <Info>
          <Name>{artist.displayName}</Name>
          <span>@{artist.accountId}</span>
        </Info>
      </CardActionArea>
    </Card>
  )
}

const useStyle = makeStyles({
  card: {
    display: 'inline-block',
    height: '100%',
    width: '100%',
    boxShadow: 'none',
    overflow: 'none',
  },
  imgWrapper: {
    width: '100%',
    height: '100%',
  },
  img: {
    borderRadius: '10%',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0 /* Make the picture taking the size of it's parent */,
    width: '100%' /* This if for the object-fit */,
    height: '100%' /* This if for the object-fit */,
    objectFit:
      'cover' /* Equivalent of the background-size: cover; of a background-image */,
    objectPosition: 'center',
  },
})

const SquareBox = styled.div`
  position: relative;
  width: 100%;
  &:before {
    content: '';
    display: block;
    position: absolute;
    padding-bottom: 100%;
  }
`

const Name = styled.span({
  fontWeight: 600,
})

const Info = styled.div({
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Helvetica',
  margin: '10px 0',
})
